import React from 'react'

export default function CheckboxActiveIcon(){
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="20" height="20" rx="4.44444" fill="#453CFB"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M17.3875 8.69671C17.7731 9.04818 17.7731 9.61803 17.3875 9.9695L11.4832 15.3511C11.0594 15.7373 10.3725 15.7373 9.94877 15.3511L6.43374 12.1473C6.04813 11.7958 6.04813 11.226 6.43374 10.8745C6.81936 10.523 7.44456 10.523 7.83018 10.8745L10.716 13.5048L15.9911 8.69671C16.3767 8.34524 17.0019 8.34524 17.3875 8.69671Z" fill="white"/>
        </svg>
    )
}
